/**
 * getItemColor uses a lookup table to return the correct color for your KPI territory country items
 * Tt will not work for other KPI's/components!
 * @param {object} item The item you want to find the right color for. It needs to have a compareArrayIndex property.
 * @param {string|undefined} compareMode Undefined if no compareMode is active. A string (entity/country) if it is
 * @param {array} dataColors A list of colors to use
 * @returns {string|undefined} A color in string format if it's found, or undefined if the lookup failed.
 */
const getItemColor = (
  item: any,
  compareMode: string | undefined,
  dataColors: string[]
): string | undefined => {
  // colors are only relevant in compare mode
  if (compareMode) {
    if (Array.isArray(dataColors)) {
      // We use compareArrayIndex as a lookup, which is precalculated
      if (compareMode === 'country') {
        return dataColors[item.compareArrayIndex];
      }
      // Use the normal index when using entity compare, as the order is not flexible there
      return dataColors[item.index];
    }
  }
  // Undefined is fine as well, as React will ignore this prop and
  // the data component will fallback to use a default color
  return dataColors[0];
};

export default getItemColor;
